"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContextMenu;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ContextMenuModule = _interopRequireDefault(require("./ContextMenu.module.scss"));

var _BorderedBox = _interopRequireDefault(require("../../common/BorderedBox/BorderedBox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ContextMenu(_ref) {
  var entries = _ref.entries,
      onClickEntry = _ref.onClickEntry,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var renderEntry = (0, _react.useCallback)(function (entry) {
    var label = entry.label,
        onClick = entry.onClick,
        isDisabled = entry.isDisabled;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_ContextMenuModule.default.entry, isDisabled && _ContextMenuModule.default.isDisabled)
    }, /*#__PURE__*/_react.default.createElement("a", {
      onClick: isDisabled ? undefined : function () {
        if (onClick) onClick();
        if (onClickEntry) onClickEntry();
      }
    }, label));
  }, [onClickEntry]);
  return /*#__PURE__*/_react.default.createElement(_BorderedBox.default, {
    type: "TOOLTIP_3",
    className: (0, _classnames.default)(_ContextMenuModule.default.menu, className),
    style: style
  }, entries.map(function (entry) {
    return renderEntry(entry);
  }));
}